import { type BaseOutletRepository } from "../../_Bases/BaseOutletRepository";
import { type LocalDatabaseOutlet } from "../../_Bases/BaseOutletRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBOutletRepository extends BaseIndexedDBRepository<
    LocalDatabaseOutlet
> implements BaseOutletRepository {
    public readonly source: InternalIndexedDBDatabase["outlets"];
    protected readonly dataTypeName = "Outlet";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.outlets;
    }
}
